import { pxToRem } from '../../utils';
import theme from '../../theme.style';

export default {
  root: {
    position: 'relative',
    selectors: {
      // callout hover
      '&.ms-TextField > .ms-TextField-wrapper > .ms-Stack > .ms-TooltipHost > .ms-Button:hover': {
        color: theme.palette.themePrimary,
      },
      '&.ms-TextField > .ms-TextField-wrapper > .ms-Stack': {
        display: 'block',
        marginBottom: pxToRem(4),
      },
      '&.ms-TextField > .ms-TextField-wrapper > .ms-Stack > .ms-Label': {
        display: 'inline',
      },
    },
  },
  asterisk: {
    root: {
      color: theme.palette.accentError,
      paddingLeft: pxToRem(5),
      fontWeight: 600,
    },
  },
  errorMessage: {
    borderColor: theme.palette.accentError,
    color: theme.palette.accentError,
  },
  field: {
    backgroundColor: theme.palette.neutralWhite,
    fontWeight: 400,
    selectors: {
      '&::placeholder': {
        color: theme.palette.neutralSecondary,
        fontWeight: 400,
      },
    },
  },
  fieldGroup: {
    backgroundColor: theme.palette.neutralWhite,
    borderColor: theme.palette.neutralTertiary,
    fontColor: theme.palette.neutralSecondary,
    selectors: {
      '&:focus': {
        borderColor: theme.palette.neutralDark,
      },
      '&:hover': {
        borderColor: theme.palette.themeDarkerAlt,
      },
      '& [disabled]': {
        backgroundColor: theme.palette.neutralLighter,
      },
      '& [disabled]::placeholder': {
        color: theme.palette.neutralTertiary,
      },
    },
  },
  description: {
    fontSize: 'small',
    float: 'right',
    paddingTop: '5px',
  },
  rightPadding: {
    paddingRight: pxToRem(5),
  },
};
